import React, { useState } from "react";
import UniversalDataGrid from "../../components/DataGrid";
import LineMeter from "../../components/LineMeter";
import {Box} from "@mui/material";
import DetailsDialog from "./InvDetails";
import {SiteContext} from "../../utils/SiteContext";

export default function InventoryPage() {
    const [selectedRow, setSelectedRow] = useState(null);
    const {userInfo} = React.useContext(SiteContext);
    const [user] = userInfo;

    const handleRowClick = (params) => {
        setSelectedRow(params.row);
    };

    const handleClose = () => {
        setSelectedRow(null);
    };

    const columns = [
        ...(user.staff ? [{ field: 'cust', headerName: 'Cust', flex: .5}] : []),
        { field: 'item_name', headerName: 'WCA #', flex: 1 },
        { field: 'cust_part', headerName: 'Cust Part #', flex: 1, sortComparator: true },
        { field: 'prod_type', headerName: 'Product Type', flex: 1.5, sortComparator: true },
        { field: 'description', headerName: 'Description', flex: 3, sortComparator: true },
        { field: 'manufacturer', headerName: 'Manufacturer', flex: 1, sortComparator: true },
        { field: 'class_type', headerName: 'Class', flex: 1, sortComparator: true },
        { field: 'consign', headerName: 'Consigned', flex: .75, sortComparator: true },
        { field: 'lead_time', headerName: 'Lead Time', flex: .75, sortComparator: true },
        {
            field: 'priority',
            headerName: 'Priority',
            flex: 0.5,
            sortComparator: true,
            valueFormatter: (params) => {
                const raw = params.value;
                if (raw == null) return "";
                // Clean string: trim whitespace AND remove carriage returns / newlines
                const v = raw.toString().replace(/[\r\n]/g, "").trim();
                return v === "Y" ? "" : v;
            },
        },
        { field: 'avail', headerName: 'Available', type: 'number', flex: .75, sortComparator: true },
        {
            field: 'inventory_level',
            headerName: 'Inventory Level',
            flex: 1,
            renderCell: (params) => (
                <LineMeter
                    curr={params.row.avail}
                    min={params.row.min_qty}
                    max={params.row.max_qty}
                />
            ),
            sortComparator: (v1, v2, param1, param2) => {
                const row1 = param1.api.getRow(param1.id);
                const row2 = param2.api.getRow(param2.id);
                
                const getRatio = (avail, max) => {
                    if (max === 0) return avail > 0 ? 100 : 0;
                    return (avail / max) * 100;
                };

                const ratio1 = getRatio(row1.avail, row1.max_qty);
                const ratio2 = getRatio(row2.avail, row2.max_qty);
                return ratio2 - ratio1;
            }
        },
    ];

    const mobileColumns = columns;

    return (
        <Box>
            <UniversalDataGrid
                source="invitem"
                endpoint="InvAllList"
                downloadKey="InvDownload"
                columns={columns}
                mobileColumns={mobileColumns}
                searchLabel="Inventory"
                customSortField="item_name"
                onRowClick={handleRowClick}
                tooltipFields={["description", "item_name", "cust_part", "prod_type"]}
                // initiallyHiddenColumns={["class_type","consign","lead_time","priority"]}
                mobilePrimaryFields={["item_name", "avail", "description"]}
            />
            <DetailsDialog
                open={!!selectedRow}
                onClose={handleClose}
                selectedRow={selectedRow}
            />
        </Box>
    );
}
